// Styles SCSS
import "../sass/app.scss";
// Masonry layout
import Masonry from "./utils/masonry";

// SVG polyfiil
import "svgxuse";

// Accordions
import Accordion from "accordion-js";

//Tabs
import { Tabs } from "./utils/tabs";

// pushbar
import Pushbar from "./utils/pushbar";

// Lightbox
import "./utils/fancybox";

// pagination
import "./jquery-pagination";

import datepicker from "js-datepicker";

// LazyLoad
import lazyLoadInit from "./lazyload-init";

lazyLoadInit();

$(document).ready(() => {
  // Gtranslate
  jQuery('.header__lang option:contains("Select Language")').text("langues");
  jQuery('.header__lang option:contains("English")').text("En");
  jQuery('.header__lang option:contains("French")').text("Fr");
  jQuery('.header__lang option:contains("Spanish")').text("Es");
  jQuery('.header__lang option:contains("Fr")').attr("selected", true);

  jQuery(".icon__plus").on("click", function () {
    jQuery(".jesuis").slideToggle();
  });

  if (document.querySelector(".accordion-container") !== null) {
    new Accordion(".accordion-container");
  }
  if (document.querySelector(".tabs-container") !== null) {
    new Tabs({
      elem: "tabs",
      open: 0,
    });
  }

  new Pushbar({
    blur: false,
    overlay: false,
  });

  $('[data-fancybox="galerie"], .gallery-item a').fancybox({
    thumbs: {
      autoStart: true,
    },
  });
  $('[data-fancybox="galerie-videos"], .gallery-item a').fancybox({
    thumbs: {
      autoStart: true,
    },
    youtube: {
      controls: 0,
      showinfo: 0,
    },
    vimeo: {
      color: "f00",
    },
  });

  if (document.querySelector(".galerie") !== null) {
    const grid = document.querySelector(".galerie");
    new Masonry(grid, {
      itemSelector: ".galerie__item",
      columnWidth: 285,
      gutter: 10,
    });
  }
  if (document.querySelector(".galerie-video") !== null) {
    const grid_video = document.querySelector(".galerie-video");
    new Masonry(grid_video, {
      itemSelector: ".galerie__item",
      columnWidth: 285,
      gutter: 10,
    });
  }

  // jQuery('path').each(function() {
  // 	var clas = jQuery(this).attr('class');
  // 	var clas1 = clas.split(' ')[1];
  // 	jQuery(this).on('click', function() {
  // 		jQuery('.area').removeClass('active');
  // 		jQuery('.carte__container span').removeClass('active');
  // 		jQuery('.carto__container span').removeClass('active');
  // 		jQuery('.communes__item').removeClass('active');
  // 		jQuery(this).addClass('active');
  // 		jQuery('.' + clas1).addClass('active');
  // 	});
  // });

  $("#submit-filter-annuaire").on("click", function (e) {
    e.preventDefault;

    var filter = $("#filter-annuaires");
    var loading = $(".load-bar");
    $.ajax({
      url: filter.attr("action"),
      data: filter.serialize(),
      type: "POST",
      action: "ajax_function_annuaire",
      beforeSend: function () {
        $(".emploi").html("");
        loading.toggleClass("invisible");
      },
      success: function (data) {
        loading.toggleClass("invisible");
        $(".emploi").html(data);
        $(".emploi-container").pagify(15, ".emploi__item");
      },
    });
    return false;
  });

  $(".emploi-container").pagify(15, ".emploi__item");

  datepicker(".date-debut", {
    startDay: 1,
    customMonths: [
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre",
    ],
    customDays: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Vend", "Sam"],
    formatter: (input, date, instance) => {
      const value = date.toLocaleDateString("fr-FR");
      input.value = value; // => '1/1/2099'
    },
  });
  datepicker(".date-fin", {
    startDay: 1,
    customMonths: [
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre",
    ],
    customDays: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Vend", "Sam"],
    formatter: (input, date, instance) => {
      const value = date.toLocaleDateString("fr-FR");
      input.value = value; // => '1/1/2099'
    },
  });
});
